// Setting up the mock API test environment, based on which environment
// we are currently running in.
// Taken from:
// https://github.com/kentcdodds/bookshelf/blob/7dd12cf8f4f38bd60f5798d0efa8eb4dff09d277/src/test/server/index.js

const seedFaker = async () => (await import('faker')).default.seed(123);

export async function init() {
    if (process.env.NODE_ENV === 'test') {
        await seedFaker();
        await import('./test-server');
    } else if (
        process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_MOCK_API === 'true'
    ) {
        await seedFaker();
        await import('./dev-server');
    } else {
        // PRODUCTION ENVIRONMENT:
        // do nothing in production, all calls will just be made to the API
    }
}
